module.exports = __webpack_public_path__ + "img/productPage3.0b9e33c8.png";